import React from 'react'
import { usePopper } from 'react-popper'

import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import { useSETrackEventCertificates } from 'app/ProfileRevampPage/hooks/useSETrackEventCertificates'
import { useProfileCertificateOnboarding } from 'stores/profile'

const CertificateTooltip = ({ referenceElement }) => {
  const [popperElement, setPopperElement] = React.useState(null)
  const [arrowElement, setArrowElement] = React.useState(null)
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'bottom-start',
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 12],
        },
      },
      { name: 'arrow', options: { element: arrowElement } },
      {
        name: 'flip',
        options: {
          fallbackPlacements: [],
        },
      },
    ],
  })
  const profileCertificateOnboardingStore = useProfileCertificateOnboarding()
  const { SETrackCertificateList } = useSETrackEventCertificates()

  return (
    <>
      {/* eslint-disable react/no-unknown-property */}
      <style jsx global>
        {`
          #certificate-tooltip #certificate-tooltip-arrow,
          #certificate-tooltip #certificate-tooltip-arrow::before {
            position: absolute;
            width: 16px;
            height: 16px;
            background: inherit;
            left: 0px;
            right: auto;
            z-index: -1;
          }

          #certificate-tooltip #certificate-tooltip-arrow {
            visibility: hidden;
          }

          #certificate-tooltip #certificate-tooltip-arrow::before {
            visibility: visible;
            content: '';
            transform: rotate(45deg);
          }

          #certificate-tooltip[data-popper-placement^='top-start']
            > #certificate-tooltip-arrow {
            bottom: -4px;
            left: 16px !important;
          }

          #certificate-tooltip[data-popper-placement^='bottom-start']
            > #certificate-tooltip-arrow {
            top: -4px;
            left: 18px !important;
          }

          #certificate-tooltip[data-popper-placement^='left']
            > #certificate-tooltip-arrow {
            right: -4px;
          }

          #certificate-tooltip[data-popper-placement^='right']
            > #certificate-tooltip-arrow {
            left: -4px;
          }
        `}
      </style>
      <div
        ref={setPopperElement}
        id="certificate-tooltip"
        style={styles.popper}
        {...attributes.popper}
        className="z-[1] pl-4 pr-3 py-2 text-white rounded-lg shadow-card bg-blue-70 relative"
      >
        <Text
          variant="helper"
          color="inverse"
          className="flex items-center gap-x-2"
        >
          Tanggal pelaksanaan{' '}
          <Icon
            color="inverse"
            fontSize="sm"
            onClick={(e) => {
              e.preventDefault()
              profileCertificateOnboardingStore.setFinished()
              SETrackCertificateList('CLOSE_TOOLTIP_SERTIFIKAT_SECTION')
            }}
          >
            close
          </Icon>
        </Text>
        <div ref={setArrowElement} id="certificate-tooltip-arrow" />
      </div>
    </>
  )
}

export default CertificateTooltip
